import React from 'react';
import styled from '@emotion/styled';
import { computeOrderDuration, Order, OrderPhaseStatus } from '../models/order';
import { MINUTE_IN_MS } from '../lib/time';

export interface OrderStatusBarProps {
  order: Order;
  maxDuration?: number;
}

export const COLORS = ['#f2c94c', '#f2c94c', '#2f7df6', '#acd5bc', '#3c6'];

export default ({
  order,
  maxDuration = computeOrderDuration(order),
}: OrderStatusBarProps) => {
  const maxDurationMinutes = maxDuration / MINUTE_IN_MS;

  return (
    <StyledContainer>
      {order.phaseStatuses.map((phaseStatus) => {
        const durationMinutes = computeStatusDurationMinutes(phaseStatus);
        const width = (durationMinutes / maxDurationMinutes) * 100 + '%';

        return (
          <li key={phaseStatus.phase.name} style={{ width }}>
            {phaseStatus.phase.name}: {durationMinutes} minutes
          </li>
        );
      })}
    </StyledContainer>
  );
};

export const computeStatusDurationMinutes = (
  status: OrderPhaseStatus
): number => {
  const started = (status.started) ? new Date(status.started.replace(/-/g, "/")) : new Date();
  const ended = (status.ended) ? new Date(status.ended.replace(/-/g, "/")) : new Date();

  return Math.ceil(
    Math.abs(started.valueOf() - ended.valueOf()) /
    1000 /
    60
  );
};

export const StyledContainer = styled.ul`
  --border-rounding: 6px;

  min-width: 272px;
  height: 16px;
  padding: 0;
  margin: 0;
  overflow: hidden;
  display: flex;

  li {
    overflow: hidden;
    text-indent: -9999px;
    background: #ccc;
    min-width: 5px;
    margin: 0;

    &:last-child {
      border-top-right-radius: var(--border-rounding);
      border-bottom-right-radius: var(--border-rounding);
    }

    &:nth-of-type(1) {
      background: ${COLORS[0]};
      border-top-left-radius: var(--border-rounding);
      border-bottom-left-radius: var(--border-rounding);
    }

    &:nth-of-type(2) {
      background: ${COLORS[1]};
    }

    &:nth-of-type(3) {
      background: ${COLORS[2]};
    }

    &:nth-of-type(4) {
      background: ${COLORS[3]};
    }

    &:nth-of-type(5) {
      background: ${COLORS[4]};
    }
  }
`;
